import { Injectable } from '@angular/core';
import { RoleEntity } from './role.entity';
import { MesApiService } from 'common-shared';
import { map } from 'rxjs/operators';
import { plainToInstance } from 'class-transformer';
import { RoleModel } from './role.model';
import {PrivilegeEntity} from "./privilege.entity";

@Injectable({ providedIn: 'root' })
export class RoleService extends MesApiService {
  constructor() {
    super('role');
  }

  $getAll = this.getAll();

  getAll() {
    return this.getList<RoleEntity>({action: 'GetAll'})
      .pipe(map(value => plainToInstance(RoleEntity, value.data)));
  }

  getAllPrivileges() {
    return this.getList<PrivilegeEntity>({action: 'GetAllPrivileges'})
      .pipe(map(value => plainToInstance(PrivilegeEntity, value.data)));
  }

  loadOne(id: string) {
    return this
      .getSingle<RoleModel>({ id })
      .pipe(map(value => plainToInstance(RoleModel, value.data)));
  }

  addNew(role: RoleModel) {
    return this
      .add<RoleModel>(role)
      .pipe(map(value => plainToInstance(RoleModel, value.data)));
  }

  save(role: RoleModel) {
    return this
      .update<RoleModel>(role.Id, role)
      .pipe(map(value => plainToInstance(RoleModel, value.data)));
  }

  remove(role: RoleModel) {
    return this
      .delete<RoleModel>(role.Id)
      .pipe(map(value => plainToInstance(RoleModel, value.data)));
  }
}
